export default __webpack_public_path__ + "static/media/ruleOrange.26d9b2e7.svg";